import ActiveCallDeviceSelector from "./ActiveCallDeviceSelector";

export default ActiveCallDeviceSelector;
